import classNames from 'classnames'
import styles from './BackToTop.module.scss'
import { useTranslation } from 'next-i18next'
import { Heading } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'

const BackToTop = () => {
  // I18N
  const { t } = useTranslation(['referral'])

  return (
    <section className={classNames('container section', styles.root)}>
      <div className={classNames('card', styles.card)}>
        <Heading as="h2" variant="d3" className="mb-500">
          {t('referral.backToTop.title')}
        </Heading>
        <p>{t('referral.backToTop.paragraph')}</p>
        <Link as="a" href="#referral-hero" representation="button">
          {t('referral.backToTop.button')}
        </Link>
      </div>
    </section>
  )
}

export default BackToTop
